import styled from 'styled-components'

export const Page = styled.main`
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
    padding: 120px clamp(18px, 4vw, 52px) 72px;
    animation: notificationDetailReveal 0.48s ease both;

    @keyframes notificationDetailReveal {
        from { opacity: 0; transform: translateY(12px); }
        to { opacity: 1; transform: translateY(0); }
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export const DetailSurface = styled.section`
    width: 100%;
`;
